import dataService from './dataService.js'

// Utility function to load CFB data using the centralized data service
export async function loadLocalGameData(date = null) {
  return await dataService.loadGameData(date)
}

// Utility function to get the last update timestamp
export async function getLastUpdateTime() {
  return await dataService.getLastUpdateTime()
}

// Utility function to force refresh data
export async function refreshGameData(date = null) {
  return await dataService.refreshGameData(date)
}

// Export the data service for advanced usage
export { dataService }